/**Dirección simple para reclamo */
export class EmailNotification {
    /**Descripción */
    public indContrastacion: string;
    public operRegLectura: string;
    public indNotifElectronica: string;
    public emailNotifElec: string;

}